import Select from "../../../material/select/SelectV2";
import Datepicker from "../../../material/datepicker/Datepicker";
import InputV2 from "../../../material/input/InputV2";
import {
  prefix,
  gender,
  formatThaiID,
  formatBackThaiID,
} from "../UserManagementHelper";

const PersonalInfo = ({ info, onInputChange }) => {
  return (
    <div className="w-full gap-[10px] rounded-[6px] border-[#E2E2E4] border p-[9px_16px] mb-[10px]">
      <h1 className="text-[18px] mb-[10px]">ข้อมูลส่วนตัว</h1>

      <div className="flex justify-center items-center flex-row gap-[16px] md:flex-col w-full mb-[16px]">
        <div className="flex flex-col text-[16px] font-['Prompt'] w-[30%] md:w-full">
          คำนำหน้า
          <Select
            lable="คำนำหน้า"
            value={info.prefix}
            setValue={(value) => onInputChange("prefix", value)}
            list={prefix}
            placeholder="คำนำหน้า"
          />
        </div>

        <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
          ชื่อ
          <InputV2
            type="text"
            placeholder="กรอกชื่อ"
            value={info.firstName}
            onChangeEvt={(value) => onInputChange("firstName", value)}
          />
        </div>

        <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
          นามสกุล
          <InputV2
            type="text"
            placeholder="กรอกนามสกุล"
            value={info.lastName}
            onChangeEvt={(value) => onInputChange("lastName", value)}
          />
        </div>
      </div>

      <div className="flex flex-row gap-[16px] md:flex-col w-full mb-[16px]">
        <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
          เลขบัตรประชาชน
          <InputV2
            type="text"
            placeholder="เลขบัตรประชาชน"
            value={formatThaiID(info.id_card)}
            onChangeEvt={(value) => onInputChange("id_card", value)}
          />
        </div>

        {/* <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
          เลขหลังบัตรประชาชน
          <InputV2
            type="text"
            placeholder="เลขหลังบัตรประชาชน"
            value={formatBackThaiID(info.laser)}
            onChangeEvt={(value) => onInputChange("laser", value)}
          />
        </div> */}
      </div>

      <div className="flex flex-row gap-[16px] md:flex-col w-full mb-[16px]">
        <div className="flex flex-col text-[16px] font-['Prompt'] md:w-full">
          เพศ
          <Select
            value={info.gender}
            setValue={(value) => onInputChange("gender", value)}
            list={gender}
            placeholder="เลือกเพศ"
          />
        </div>

        <div className="flex flex-col text-[16px] font-['Prompt'] w-[170px] md:w-full">
          วัน/เดือน/ปีเกิด
          <Datepicker
            value={info.birthday}
            setValue={(value) => onInputChange("birthday", value)}
          />
        </div>
      </div>
    </div>
  );
};

export default PersonalInfo;
